export default "__VITE_ASSET__Enn4j0J8__"